/** Outbound WhatsApp delivery state in words for the operator. */
export function deliveryState(status: string, errorCode?: string | null): { label: string; tone: "sent" | "pending" | "failed" | "uncertain" } | null {
  if (status === "sent") return { label: "Enviado", tone: "sent" };
  if (["queued", "processing", "pending", "claimed"].includes(status)) return { label: "Pendiente de envío", tone: "pending" };
  if (status === "delivery_uncertain" || errorCode === "delivery_uncertain") return { label: "Entrega incierta", tone: "uncertain" };
  if (status === "quarantined") return { label: "En revisión", tone: "uncertain" };
  if (status === "failed") return { label: "No enviado", tone: "failed" };
  return null;
}
